import { LOCAL_STORAGE_LANGUAGE_KEY } from "./hooks/useAppLanguage";
import { isSupportedLanguage, LanguageCode } from "./i18n/languages";

let fallbackLanguage;

const localStorageLanguage = localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY);

if (localStorageLanguage && isSupportedLanguage(localStorageLanguage)) {
    fallbackLanguage = localStorageLanguage as LanguageCode;
}

export const config = {
    fallbackLanguage: fallbackLanguage || 'sr' as LanguageCode
};
